import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

export default function CssfPdfFooter() {
    const styles = StyleSheet.create( {
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
        footerText: {
            color: 'white',
            position: 'absolute',
            marginTop: 25,
            marginLeft: 20,
            fontSize: 10,
        },
    } );

    return (
        <View style={ [ styles.footer, { marginTop: 50 } ] } fixed>
            <Image style={ { height: 80, width: 55, marginLeft: 20 } } src={ "/cssf-footer.png" }/>
            <View style={ { position: "absolute", top: 15, left: 100 } }>
                <Text style={ { top: 12, color: "#006D88", fontSize: "8px", fontWeight: "bold" } }>
                    Commission de Surveillance du Secteur Financier
                </Text>
                <Text style={ { top: 12, color: "#006D88", fontSize: "8px" } }>
                    283, route d’Arlon – L-2991 Luxembourg – (+352) 26 25 1-1 – direction@cssf.lu – TVA LU17756005
                </Text>
                <Text style={ { top: 12, color: "#006D88", fontSize: "8px", fontWeight: "bold" } }>
                    www.cssf.lu
                </Text>
            </View>
            <Text style={ [ styles.footerText, { top: 25, right: 20, fontSize: 8, color: "#000000" } ] }
                  render={ ( { pageNumber, totalPages } ) => (
                      `${ pageNumber } / ${ totalPages }`
                  ) }/>
        </View>
    );
}
